import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$defaultuw5a81aphnfp as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance3ib8lrmu0w6c5 as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().q4e("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.k4e_1 = null;
        this.l4e_1 = null;
        this.m4e_1 = 0n;
      }
      q2() {
        return this.m4e_1;
      }
      r3x() {
        return this;
      }
      s3x() {
        return this.q2() === 0n;
      }
      t3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().q4e("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      y3x(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      b3y() {
        var tmp0_elvis_lhs = this.k4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.y4e();
          return this.b3y();
        }
        var v = segment.z4e();
        this.m4e_1 = subtract(this.m4e_1, 1n);
        if (segmentSize === 1) {
          this.y4e();
        }
        return v;
      }
      a4f() {
        var tmp0_elvis_lhs = this.k4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.t3x(2n);
          if (segmentSize === 0) {
            this.y4e();
            return this.a4f();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.b3y() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.b3y() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.b4f();
        this.m4e_1 = subtract(this.m4e_1, 2n);
        if (segmentSize === 2) {
          this.y4e();
        }
        return v;
      }
      c4f() {
        return Unit_instance;
      }
      d4f(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.m4e_1 = add(out.m4e_1, remainingByteCount);
        var s = this.k4e_1;
        while (currentOffset >= fromInt(ensureNotNull(s).t4e_1 - s.s4e_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.t4e_1 - s.s4e_1 | 0));
          s = s.w4e_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).e4f();
          copy.s4e_1 = copy.s4e_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.s4e_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.t4e_1;
          tmp.t4e_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.k4e_1 == null) {
            out.k4e_1 = copy;
            out.l4e_1 = copy;
          } else if (false) {
            out.l4e_1 = ensureNotNull(out.l4e_1).f4f(copy).g4f();
            if (ensureNotNull(out.l4e_1).x4e_1 == null) {
              out.k4e_1 = out.l4e_1;
            }
          } else {
            out.l4e_1 = ensureNotNull(out.l4e_1).f4f(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.t4e_1 - copy.s4e_1 | 0));
          currentOffset = 0n;
          s = s.w4e_1;
        }
      }
      h4f() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.l4e_1);
        if (tail.t4e_1 < 8192 && tail.v4e_1) {
          result = subtract(result, fromInt(tail.t4e_1 - tail.s4e_1 | 0));
        }
        return result;
      }
      o3w(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.k4e_1).i4f(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.k4e_1 == null) {
            return ensureNotNull(null).i4f(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.l4e_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.t4e_1 - s.s4e_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.x4e_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).i4f(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.k4e_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.t4e_1 - s_0.s4e_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.w4e_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).i4f(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      a5() {
        return this.c3v(this.q2());
      }
      c3v(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.k4e_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().q4e('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.t4e_1 - head.s4e_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.m4e_1 = subtract(this.m4e_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.s4e_1 = head.s4e_1 + toSkip | 0;
          if (head.s4e_1 === head.t4e_1) {
            this.y4e();
          }
        }
      }
      j4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.k4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.k4f(sink, startIndex, startIndex + toCopy | 0);
        this.m4e_1 = subtract(this.m4e_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.y4e();
        }
        return toCopy;
      }
      l4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.m4f(this, bytesWritten);
        return bytesWritten;
      }
      n4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.m4f(this, this.q2());
          throw EOFException().q4e('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.m4f(this, byteCount);
      }
      o4f(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.m4f(this, byteCount);
        }
        return byteCount;
      }
      w3z() {
        return buffered(new (PeekSource())(this));
      }
      p4f(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.l4e_1 == null) {
          var result = SegmentPool_instance.f3w();
          this.k4e_1 = result;
          this.l4e_1 = result;
          return result;
        }
        var t = ensureNotNull(this.l4e_1);
        if ((t.t4e_1 + minimumCapacity | 0) > 8192 || !t.v4e_1) {
          var newTail = t.f4f(SegmentPool_instance.f3w());
          this.l4e_1 = newTail;
          return newTail;
        }
        return t;
      }
      s4f(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.p4f(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.t4f();
          var toCopy = Math.min(tmp0, b);
          tail.u4f(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.m4e_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.m4e_1 = add(tmp0_0, fromInt(other));
      }
      m4f(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().n2(toString(message));
        }
        checkOffsetAndCount(source.m4e_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.k4e_1).q2())) {
            var tail = this.l4e_1;
            var tmp;
            if (!(tail == null) && tail.v4e_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.t4e_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.w4f() ? 0 : tail.s4e_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.k4e_1).y4f(tail, convertToInt(remainingByteCount));
              source.m4e_1 = subtract(source.m4e_1, remainingByteCount);
              this.m4e_1 = add(this.m4e_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.k4e_1 = ensureNotNull(source.k4e_1).x4f(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.k4e_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.k4e_1 = segmentToMove.z4f();
          if (source.k4e_1 == null) {
            source.l4e_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.k4e_1 == null) {
            this.k4e_1 = segmentToMove;
            this.l4e_1 = segmentToMove;
          } else if (true) {
            this.l4e_1 = ensureNotNull(this.l4e_1).f4f(segmentToMove).g4f();
            if (ensureNotNull(this.l4e_1).x4e_1 == null) {
              this.k4e_1 = this.l4e_1;
            }
          } else {
            this.l4e_1 = ensureNotNull(this.l4e_1).f4f(segmentToMove);
          }
          source.m4e_1 = subtract(source.m4e_1, movedByteCount);
          this.m4e_1 = add(this.m4e_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      a4g(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.l4f(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      b4g(byte) {
        this.p4f(1).c4g(byte);
        this.m4e_1 = add(this.m4e_1, 1n);
      }
      d4g(short) {
        this.p4f(2).e4g(short);
        this.m4e_1 = add(this.m4e_1, 2n);
      }
      l6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().tb(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.k4e_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.f4g(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.w4e_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      y4e() {
        var oldHead = ensureNotNull(this.k4e_1);
        var nextHead = oldHead.w4e_1;
        this.k4e_1 = nextHead;
        if (nextHead == null) {
          this.l4e_1 = null;
        } else {
          nextHead.x4e_1 = null;
        }
        oldHead.w4e_1 = null;
        SegmentPool_instance.g4g(oldHead);
      }
      h4g() {
        var oldTail = ensureNotNull(this.l4e_1);
        var newTail = oldTail.x4e_1;
        this.l4e_1 = newTail;
        if (newTail == null) {
          this.k4e_1 = null;
        } else {
          newTail.w4e_1 = null;
        }
        oldTail.x4e_1 = null;
        SegmentPool_instance.g4g(oldTail);
      }
    }
    protoOf($).v4f = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
